export interface MarkdownSegment {
  text: string;
  bold: boolean;
  italic: boolean;
  code: boolean;
}

const INLINE_MARKDOWN_PATTERN = /\*\*\*(.+?)\*\*\*|\*\*(.+?)\*\*|\*(.+?)\*|`(.+?)`/g;

export function parseInlineMarkdown(input: string): MarkdownSegment[] {
  const segments: MarkdownSegment[] = [];
  let lastIndex = 0;

  INLINE_MARKDOWN_PATTERN.lastIndex = 0;
  let match = INLINE_MARKDOWN_PATTERN.exec(input);
  while (match !== null) {
    if (match.index > lastIndex) {
      segments.push({
        text: input.slice(lastIndex, match.index),
        bold: false,
        italic: false,
        code: false,
      });
    }
    const [, boldItalic, bold, italic, code] = match;
    if (boldItalic !== undefined) {
      segments.push({ text: boldItalic, bold: true, italic: true, code: false });
    } else if (bold !== undefined) {
      segments.push({ text: bold, bold: true, italic: false, code: false });
    } else if (italic !== undefined) {
      segments.push({ text: italic, bold: false, italic: true, code: false });
    } else if (code !== undefined) {
      segments.push({ text: code, bold: false, italic: false, code: true });
    }
    lastIndex = INLINE_MARKDOWN_PATTERN.lastIndex;
    match = INLINE_MARKDOWN_PATTERN.exec(input);
  }
  if (lastIndex < input.length) {
    segments.push({ text: input.slice(lastIndex), bold: false, italic: false, code: false });
  }
  return segments;
}
